import { useLayoutEffect } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useMatch,
  useParams,
  useLocation
} from 'react-router-dom';
import { APP_BASE_PATH, OLD_APP_BASE_PATH } from './utilities/appBasePath';
import { rewriteUrl } from './utilities/routes';
import AuthProvider from './context/AuthProvider';
import HomeRedirect from './components/HomeRedirect';
import ImpersonationRouter from './components/ImpersonationRouter';
import mfeConfig from './mfeConfig';
import AppraisalModule from './modules/Appraisal';
import VehicleEntryContainer from './modules/VinEntry';
import HubModule from './modules/Hub';
import BasePage from './components/_shared/BasePage';
import Unauthorized from './components/Auth/Unauthorized';

const IdRedirect = () => {
  const params = useParams();
  const id = params.id.match(/\d+/);
  if (!id) {
    return <Navigate to={APP_BASE_PATH} />;
  }
  return <Navigate to={`${APP_BASE_PATH}/hub/${params.id}`} />;
};

const IdRedirectWithPage = () => {
  const params = useParams();
  const id = params.id.match(/\d+/);
  if (!id) {
    return <Navigate to={APP_BASE_PATH} />;
  }
  return <Navigate to={`${APP_BASE_PATH}/hub/${params.id}?force=${params.page}`} />;
};

const BasePageController = ({ children }: { children: JSX.Element }) => {
  const match = useMatch(`${APP_BASE_PATH}/:page/*`);

  const transpose = match?.params.page === 'getoffer' || match?.params.page === 'vin-entry';

  return <BasePage transpose={transpose}>{children}</BasePage>;
};

const NavigateToNewBasePath = () => {
  const location = useLocation();

  return (
    <Navigate
      to={rewriteUrl({
        from: OLD_APP_BASE_PATH,
        to: APP_BASE_PATH,
        location
      })}
    />
  );
};

const ShellRoutes = () => {
  useLayoutEffect(() => {
    mfeConfig();
  }, []);

  return (
    <BrowserRouter>
      <BasePageController>
        <AuthProvider>
          <Routes>
            <Route path={APP_BASE_PATH}>
              <Route path="getoffer/*" element={<AppraisalModule />} />
              <Route path="offer/*" element={<AppraisalModule />} />
              <Route path="impersonation/:id" element={<ImpersonationRouter />} />
              <Route path="unauthorized" element={<Unauthorized />} />
              <Route path=":id" element={<IdRedirect />} />
              <Route path=":id/:page" element={<IdRedirectWithPage />} />
              <Route path="confirmation/*" element={<HubModule />} />
              <Route path="hub/*" element={<HubModule />} />
              <Route path="plaid-redirect" element={<HubModule />} />
              <Route path="vin-entry" element={<VehicleEntryContainer />} />
              <Route index element={<HomeRedirect />} />
            </Route>
            <Route path={OLD_APP_BASE_PATH} element={<NavigateToNewBasePath />} />
            <Route index element={<Navigate to={APP_BASE_PATH} />} />
          </Routes>
        </AuthProvider>
      </BasePageController>
    </BrowserRouter>
  );
};

export default ShellRoutes;
